/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I find what percentage one number is of another?`)
};

const es_pct_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo hallo qué porcentaje representa un número respecto a otro?`)
};

const de_pct_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie finde ich heraus, wie viel Prozent eine Zahl von einer anderen ist?`)
};

const nl_pct_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe bepaal ik welk percentage het ene getal van het andere is?`)
};

const fr_pct_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment trouver quel pourcentage un nombre représente d'un autre ?`)
};

const it_pct_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come trovo quale percentuale un numero rappresenta di un altro?`)
};

const pt_br2_pct_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como encontro que porcentagem um número representa de outro?`)
};

const pt_pct_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como descubro que percentagem um número representa de outro?`)
};

const ja_pct_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ある数がもう一方の何パーセントかを求めるには？`)
};

const zh_pct_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何计算一个数是另一个数的百分之几？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_hub_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_hub_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_hub_faq2_q", locale)
	if (locale === "en") return en_pct_hub_faq2_q(inputs)
	if (locale === "es") return es_pct_hub_faq2_q(inputs)
	if (locale === "de") return de_pct_hub_faq2_q(inputs)
	if (locale === "nl") return nl_pct_hub_faq2_q(inputs)
	if (locale === "fr") return fr_pct_hub_faq2_q(inputs)
	if (locale === "it") return it_pct_hub_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_hub_faq2_q(inputs)
	if (locale === "pt") return pt_pct_hub_faq2_q(inputs)
	if (locale === "ja") return ja_pct_hub_faq2_q(inputs)
	return zh_pct_hub_faq2_q(inputs)
};